const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/gif", "image/png"];

enum CustomerType {
  Homeowner,
  Organization,
}

enum ATV_MAKES {
  MAJOR_ATV = "Major ATV Manufacturers",
  REGIONAL_ATV = "Regional ATV Manufacturers",
  ELECTRIC_ATV = "Electric and Hybrid ATV Brands",
  DEFUNCT_ATV = "Defunct or Lesser-Known ATV Manufacturers",
}

enum UTV_MAKES {
  MAJOR_UTV = "Major UTV Manufacturers",
  REGIONAL_UTV = "Regional UTV Manufacturers",
  ELECTRIC_UTV = "Electric and Hybrid UTV Brands",
  DEFUNCT_UTV = "Defunct or Lesser-Known UTV Manufacturers",
}

enum Boat_MAKES {
  MAJOR_BOAT = "Major Boat Manufacturers",
  REGIONAL_BOAT = "Regional Boat Manufacturers",
  ELECTRIC_BOAT = "Electric and Hybrid Boat Brands",
  DEFUNCT_BOAT = "Defunct or Historical Boat and Watercraft Manufacturers",
  PANTOON_BOAT = "Pontoon Manufacturers",
  PERSONAL_BOAT = "Personal Watercraft (PWC) Manufacturers",
}

enum Snow_MAKES {
  MAJOR_SNOW = "Major Snowmobile Manufacturers",
  REGIONAL_SNOW = "Regional Snowmobile Manufacturers",
  ELECTRIC_SNOW = "Electric and Hybrid Snowmobile Brands",
  DEFUNCT_SNOW = "Defunct or Lesser-Known Snowmobile Manufacturers",
}

enum TransactionType {
  SUBSCRIPTION = "Subscription",
  FEATURE = "Feature",
  PURCHASE = "Purchase",
}

enum ProductType {
  Sales = "For_Sale",
  ISO = "ISO",
  All = "",
}

export {
  SUPPORTED_FORMATS,
  CustomerType,
  ATV_MAKES,
  UTV_MAKES,
  Boat_MAKES,
  Snow_MAKES,
  TransactionType,
  ProductType,
};
